import { TranslateFn } from 'hooks/useTranslate';
import { getEncumbranceLabel } from 'modules/partners/components/PartnerShares/utils/getEncumbranceLabel';
import { Encumbrance } from 'types';
import { formatNumber } from 'utils/formats';

export const getEncumbranceCellValue = (
  encumbrance: Encumbrance,
  translate: TranslateFn
): string => {
  const { from, to, type, coOwners } = encumbrance ?? {};

  if (!encumbrance || to === from) {
    return '-';
  }

  const encumbranceRange = `${formatNumber(from)} - ${formatNumber(to)}`;
  const encumbranceLabel = getEncumbranceLabel(encumbrance);
  const translatedLabel = encumbranceLabel ? translate(encumbranceLabel) : type;
  const formattedLabel = translatedLabel ? `(${translatedLabel})` : '';

  const summaryLine = `${encumbranceRange} ${formattedLabel}`.trim();
  const coOwnerLines =
    coOwners?.map((coOwner) => ` • ${coOwner.name} (${coOwner.percentage}%)`) ??
    [];

  return [summaryLine, ...coOwnerLines].join('\n');
};

export const getCellValues = {};
